<template>
  <div>
    <iframe :style="'width:100%;height: ' + height" v-if="load" :src="getSrc" frameborder="0"></iframe>
  </div>
</template>
<script>
// import { isRmtEnv } from '@/core/index';
export default {
  name: 'CommonIframe',
  props: {
    src: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '600px'
    }
  },
  data() {
    return {
      load: false,
      getSrc: ''
    };
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      let _src = this.src;
      const roomId = $$.module.data.room.roomId;
      _src += _src.indexOf('?') < 0 ? `?id=${roomId}` : `&id=${roomId}`;

      if (_src.indexOf('${token}') > -1) {
        Promise.resolve($$.token.get()).then((token) => {
          this.getSrc = _src.replace('${token}', token || '');
          this.load = true;
        });
      } else {
        this.getSrc = _src;
        this.load = true;
      }
    },
    reload() {
      this.load = false;
      this.$nextTick(() => {
        this.init();
      });
    }
  }
};
</script>
